import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from '../../../utils/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from '../action-type.util';

import { IParticipantWarning, defaultValue } from '../../model/participant-warning.model';

export const ACTION_TYPES = {
  FETCH_PARTICIPANTWARNING_LIST: 'participantWarning/FETCH_PARTICIPANTWARNING_LIST',
  FETCH_PARTICIPANTWARNING: 'participantWarning/FETCH_PARTICIPANTWARNING',
  CREATE_PARTICIPANTWARNING: 'participantWarning/CREATE_PARTICIPANTWARNING',
  UPDATE_PARTICIPANTWARNING: 'participantWarning/UPDATE_PARTICIPANTWARNING',
  DELETE_PARTICIPANTWARNING: 'participantWarning/DELETE_PARTICIPANTWARNING',
  SET_BLOB: 'participantWarning/SET_BLOB',
  RESET: 'participantWarning/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IParticipantWarning>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type ParticipantWarningState = Readonly<typeof initialState>;

// Reducer

export default (state: ParticipantWarningState = initialState, action): ParticipantWarningState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_PARTICIPANTWARNING_LIST):
    case REQUEST(ACTION_TYPES.FETCH_PARTICIPANTWARNING):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_PARTICIPANTWARNING):
    case REQUEST(ACTION_TYPES.UPDATE_PARTICIPANTWARNING):
    case REQUEST(ACTION_TYPES.DELETE_PARTICIPANTWARNING):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_PARTICIPANTWARNING_LIST):
    case FAILURE(ACTION_TYPES.FETCH_PARTICIPANTWARNING):
    case FAILURE(ACTION_TYPES.CREATE_PARTICIPANTWARNING):
    case FAILURE(ACTION_TYPES.UPDATE_PARTICIPANTWARNING):
    case FAILURE(ACTION_TYPES.DELETE_PARTICIPANTWARNING):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PARTICIPANTWARNING_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_PARTICIPANTWARNING):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_PARTICIPANTWARNING):
    case SUCCESS(ACTION_TYPES.UPDATE_PARTICIPANTWARNING):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_PARTICIPANTWARNING):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.SET_BLOB: {
      const { name, data, contentType } = action.payload;
      return {
        ...state,
        entity: {
          ...state.entity,
          [name]: data,
          [name + 'ContentType']: contentType,
        },
      };
    }
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/participant-warnings';

// Actions

export const getEntities: ICrudGetAllAction<IParticipantWarning> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_PARTICIPANTWARNING_LIST,
    payload: axios.get<IParticipantWarning>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IParticipantWarning> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_PARTICIPANTWARNING,
    payload: axios.get<IParticipantWarning>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IParticipantWarning> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_PARTICIPANTWARNING,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IParticipantWarning> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PARTICIPANTWARNING,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IParticipantWarning> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_PARTICIPANTWARNING,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const setBlob = (name, data, contentType?) => ({
  type: ACTION_TYPES.SET_BLOB,
  payload: {
    name,
    data,
    contentType,
  },
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
